// UI-only permission gate — mirrors the PERMISSIONS/ROLE_PERMISSIONS map in
// src/firebase-client.js. This is NOT the security boundary —
// firestore.rules/storage.rules are (see REFACTOR_SECURITY_REPORT.md §4).
// It only hides buttons/pages that would otherwise fail server-side, so a
// denial isn't confusing; a tampered client would still be rejected by
// rules regardless of what this returns.
//
// Extracted from public/index.html's inline script (Phase 2 modularization).
// can() reads window.ML_FIREBASE at call time, same as it did inline —
// moving which module defines it doesn't change that; it still runs in the
// same browser global scope either way.
export const PERMISSIONS = Object.freeze({
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_ORDERS: 'view_orders',
  CREATE_ORDER: 'create_order',
  EDIT_ORDER: 'edit_order',
  DELETE_ORDER: 'delete_order',
  MANAGE_PRODUCTS: 'manage_products',
  DELETE_PRODUCT: 'delete_product',
  MANAGE_INVENTORY: 'manage_inventory',
  VIEW_FINANCIALS: 'view_financials',
  MANAGE_WALLET: 'manage_wallet',
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_MEMBERS: 'manage_members',
  USE_CALCULATOR: 'use_calculator',
  WIPE_DATA: 'wipe_data',
  VIEW_ACTIVITY_LOG: 'view_activity_log'
});

export function can(permission) {
  return !!(window.ML_FIREBASE && window.ML_FIREBASE.hasPermission && window.ML_FIREBASE.hasPermission(permission));
}
